var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgDownArrow = function SvgDownArrow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.291 0.705095H1.29082C1.07564 0.703947 0.864961 0.761619 0.685646 0.870759C0.506331 0.979898 0.366503 1.13556 0.283988 1.3179C0.201473 1.50024 0.18001 1.70099 0.222336 1.89456C0.264662 2.08814 0.368859 2.26576 0.521642 2.40479L7.02171 8.36864C7.22469 8.55376 7.49926 8.65768 7.78547 8.65768C8.07167 8.65768 8.34625 8.55376 8.54923 8.36864L15.0493 2.40479C15.2014 2.26636 15.3054 2.08965 15.3481 1.897C15.3907 1.70436 15.3702 1.50443 15.289 1.3225C15.2078 1.14057 15.0697 0.984809 14.892 0.874912C14.7144 0.765016 14.5052 0.705919 14.291 0.705095Z",
    fill: "#18154D"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down-arrow.2bb99a61.svg";
export { ForwardRef as ReactComponent };